import React from "react"
import ClientsAbonementsNew from "../ClientsAbonementsNew"
import { CButton, CNav, CNavItem, CNavLink } from "@coreui/react"
import { useState } from "react"
import ClientsTrainingNew from "../ClientsTrainingNew"
import ClientsComments from "../ClientsComments"
import ClientsStatus from "../ClientsStatus"
import { Switch } from "antd"
import { useDispatch, useSelector } from "react-redux"
import {
  getAbonementsClient,
  getClientTrainings,
  commentsAction,
  getTransactions,
  getLink,
  getPersonalPacket,
  statusAction,
} from "src/store/Slices/ClientsSlice"
import { DeleteOutlined } from "@ant-design/icons"
import AddAbonement from "../Modals/AddAbonement"
import AddComment from "../Modals/AddComment"
import MobileClientsAbonements from "../Mobile/MobileClientsAbonements"
import MobileClientsTrainings from "../Mobile/MobileClientsTrainings"
import MobileClientsComments from "../Mobile/MobileClientsComments"
import MobileClientLink from "../Mobile/MobileClientLink"
import MobileClientPacket from "../Mobile/MobileClientPacket"
import ClientsTransactions from "../ClientsTransactions"
import MobileClientsTransactions from "../Mobile/MobileClientsTransactions"
import ClientLink from "../ClientLink.js"
import AddLink from "../Modals/AddLink"
import AddPacket from "../Modals/AddPacket"
import ClientPacket from "../ClientPacket"
import AddStatus from "../Modals/AddStatus"
import ClientsPassages from "../ClientsPassages"
import { passagesAction } from "src/store/Slices/Administrator/PassagesSlice"

const ClientsExtraTable = ({
  clientInfo,
  mnemo,
  tabPage,
  setTabPage,
  tab,
  setTab,
  payload,
}) => {
  const dispatch = useDispatch()
  console.log("🔍 Current tab:", tab)
  console.log("🔍 clientInfo.id:", clientInfo?.id)
  // const [tab, setTab] = useState('Абонементы')
  const [isActive, setIsActive] = useState(true)
  const [isDeleted, setIsDeleted] = useState(false)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [isOpenAddEditModal, setIsOpenAddEditModal] = useState(false)
  const [isOpenAddCommentModal, setIsOpenAddCommentModal] = useState(false)
  const [isOpenAddStatusModal, setIsOpenAddStatusModal] = useState(false)

  const [isOpenAddLinkModal, setIsOpenAddLinkModal] = useState(false)
  const [isOpenAddDayModal, setIsOpenAddDayModal] = useState(false)
  const [isOpenAddPacketModal, setIsOpenAddPacketModal] = useState(false)
  const [abonementInfo, setAbonementInfo] = useState()
  const [trainingInfo, setIsTrainingInfo] = useState()
  const [commentInfo, setCommentInfo] = useState()
  const [statusInfo, setStatusInfo] = useState()
  const [transactionsInfo, setTransactionsInfo] = useState()
  const [linkInfo, setLinkInfo] = useState()
  const [packetInfo, setPacketInfo] = useState()
  const [passagesInfo, setPassagesInfo] = useState()

  const showActivityItems = (value) => {
    setIsActive(value)
    tab === "Услуги" &&
      dispatch(getClientTrainings({ clientId: clientInfo.id, isActive: value }))
    tab === "Абонементы" &&
      dispatch(
        getAbonementsClient({ clientId: clientInfo.id, isActive: value }),
      )
    tab === "Комментарии" &&
      dispatch(
        commentsAction({ flag: "get", value: { UserId: clientInfo?.id } }),
      )
    tab === "Транзакции" &&
      dispatch(getTransactions({ UserId: clientInfo?.id }))
    tab === "Ссылки на оплату" &&
      dispatch(getLink({ flag: "get", value: { UserId: clientInfo?.id } }))
    tab === "Пакеты" &&
      dispatch(
        getPersonalPacket({
          flag: "get",
          value: { UserId: clientInfo?.id },
        }),
      )
    tab === "Статус" &&
      dispatch(
        statusAction({
          flag: "get",
          value: { userId: clientInfo.id },
        }),
      )

    tab === "Проходы" &&
      dispatch(
        passagesAction({
          flag: "get",
          value: { userId: clientInfo.id },
        }),
      )
    // setPage(1)
    // setPageSize(20)
  }

  const showDeletedItems = (value) => {
    setIsDeleted(value)
    dispatch(getAbonementsClient({ clientId: clientInfo.id, isDeleted: value }))
    setPage(1)
    setPageSize(20)
  }

  const getAbonementsClientList = useSelector(
    (state) => state.ClientsSlice.getAbonementsClientList,
  )
  const getAbonementsClientListLoading = useSelector(
    (state) => state.ClientsSlice.getAbonementsClientListLoading,
  )

  const getClientTrainingsList = useSelector(
    (state) => state.ClientsSlice.getClientTrainingsList,
  )
  const getClientTrainingsListLoading = useSelector(
    (state) => state.ClientsSlice.getClientTrainingsListLoading,
  )

  const commentsList = useSelector((state) => state.ClientsSlice.commentsList)
  const commentsListLoading = useSelector(
    (state) => state.ClientsSlice.commentsListLoading,
  )

  const getClientTransactionsList = useSelector(
    (state) => state.ClientsSlice.getClientTransactionsList,
  )
  const getClientTransactionsListLoading = useSelector(
    (state) => state.ClientsSlice.getClientTransactionsListLoading,
  )

  const getClientLinkList = useSelector(
    (state) => state.ClientsSlice.getClientLinkList,
  )
  const getClientLinkListLoading = useSelector(
    (state) => state.ClientsSlice.getClientLinkListLoading,
  )

  const getClientPersonalPacketList = useSelector(
    (state) => state.ClientsSlice.getClientPersonalPacketList,
  )
  const getClientPersonalPacketListLoading = useSelector(
    (state) => state.ClientsSlice.getClientPersonalPacketListLoading,
  )

  const getClientStatusList = useSelector(
    (state) => state.ClientsSlice.getClientStatusList,
  )
  const title = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <CNav variant='tabs'>
          <CNavItem>
            <CNavLink
              style={{ cursor: "pointer" }}
              onClick={() => setTab("Абонементы")}
              active={tab === "Абонементы"}
            >
              Абонементы
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              style={{ cursor: "pointer" }}
              onClick={() => setTab("Проходы")}
              active={tab === "Проходы"}
            >
              Проходы
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              style={{ cursor: "pointer" }}
              onClick={() => setTab("Услуги")}
              active={tab === "Услуги"}
            >
              Услуги
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              style={{ cursor: "pointer" }}
              onClick={() => setTab("Комментарии")}
              active={tab === "Комментарии"}
            >
              Комментарии
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              style={{ cursor: "pointer" }}
              onClick={() => setTab("Транзакции")}
              active={tab === "Транзакции"}
            >
              Транзакции
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              style={{ cursor: "pointer" }}
              onClick={() => setTab("Ссылки на оплату")}
              active={tab === "Ссылки на оплату"}
            >
              Ссылки на оплату
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              style={{ cursor: "pointer" }}
              onClick={() => setTab("Пакеты")}
              active={tab === "Пакеты"}
            >
              Пакеты
            </CNavLink>
          </CNavItem>
          <CNavItem>
            <CNavLink
              style={{ cursor: "pointer" }}
              onClick={() => setTab("Статус")}
              active={tab === "Статус"}
            >
              Статус
            </CNavLink>
          </CNavItem>
        </CNav>
        {tab === "Абонементы" ? (
          <div style={{ display: "flex", gap: "20px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <Switch
                disabled={isDeleted}
                defaultValue={isActive}
                unCheckedChildren='Неактивные'
                checkedChildren='Активные'
                onChange={(e) => {
                  showActivityItems(e)
                }}
              />
              {
                <Switch
                  disabled={
                    !isActive ||
                    !mnemo?.children
                      ?.find((el) => el.name === "Таблица абонементов")
                      ?.children.find((ele) => ele.mnemo === "isDeletedBtn")
                  }
                  defaultValue={isDeleted}
                  checkedChildren={<DeleteOutlined />}
                  unCheckedChildren={<DeleteOutlined />}
                  onChange={(e) => {
                    showDeletedItems(e)
                  }}
                />
              }
            </div>
            <CButton
              // disabled={!mnemo?.children?.find(el => el.mnemo === 'insertBtn')}
              size='sm'
              style={{ color: "#FFF" }}
              onClick={() => {
                setIsOpenAddEditModal(true)
                setIsOpenAddDayModal(false)
              }}
              disabled={
                isDeleted ||
                !isActive ||
                !mnemo?.children
                  ?.find((el) => el.name === "Таблица абонементов")
                  ?.children.find((ele) => ele.mnemo === "insertBtn")
              }
            >
              Добавить
            </CButton>
            <CButton
              // disabled={!mnemo?.children?.find(el => el.mnemo === 'insertBtn')}
              size='sm'
              style={{ color: "#FFF" }}
              onClick={() => {
                setIsOpenAddEditModal(true)
                setIsOpenAddDayModal(true)
              }}
              disabled={
                isDeleted || !isActive
                // || !mnemo?.children
                //   ?.find((el) => el.name === "Таблица абонементов")
                //   ?.children.find((ele) => ele.mnemo === "insertBtn")
              }
            >
              Добавить одноразовый
            </CButton>
          </div>
        ) : tab === "Услуги" ? (
          <div style={{ display: "flex", gap: "10px" }}>
            {
              <Switch
                defaultValue={isActive}
                unCheckedChildren='Неактивные'
                checkedChildren='Активные'
                onChange={(e) => {
                  showActivityItems(e)
                }}
              />
            }
          </div>
        ) : tab === "Транзакции" ? (
          <div style={{ display: "flex", gap: "10px" }}></div>
        ) : tab === "Пакеты" ? (
          <div style={{ display: "flex", gap: "10px" }}>
            {" "}
            <CButton
              // disabled={!mnemo?.children?.find(el => el.mnemo === 'insertBtn')}
              size='sm'
              style={{ color: "#FFF" }}
              onClick={() => {
                setIsOpenAddPacketModal(true)
              }}
              disabled={
                !mnemo?.children
                  ?.find((el) => el.name === "Персональные пакеты клиента")
                  ?.children.find((ele) => ele.mnemo === "insertBtn")
              }
            >
              {console.log(mnemo.children)}
              Добавить
            </CButton>
          </div>
        ) : tab === "Ссылки на оплату" ? (
          <div style={{ display: "flex", gap: "10px" }}>
            <CButton
              // disabled={!mnemo?.children?.find(el => el.mnemo === 'insertBtn')}
              size='sm'
              style={{ color: "#FFF" }}
              onClick={() => {
                setIsOpenAddLinkModal(true)
              }}
              disabled={
                !mnemo?.children
                  ?.find((el) => el.name === "Ссылки клиента")
                  ?.children.find((ele) => ele.mnemo === "insertBtn")
              }
            >
              {console.log(mnemo.children)}
              Добавить
            </CButton>
          </div>
        ) : tab === "Проходы" ? (
          <></>
        ) : tabPage === "Проходы" ? (
          <></>
        ) : tab === "Комментарии" ? (
          <div style={{ display: "flex", gap: "10px" }}>
            <CButton
              size='sm'
              style={{ color: "#FFF" }}
              onClick={() => {
                setIsOpenAddCommentModal(true)
              }}
              disabled={
                !mnemo?.children
                  ?.find((el) => el.name === "Ссылки клиента")
                  ?.children.find((ele) => ele.mnemo === "insertBtn")
              }
            >
              Добавить
            </CButton>
          </div>
        ) : (
          <div style={{ display: "flex", gap: "10px" }}>
            <CButton
              // disabled={!mnemo?.children?.find(el => el.mnemo === 'insertBtn')}
              size='sm'
              style={{ color: "#FFF" }}
              onClick={() => {
                setIsOpenAddStatusModal(true)
              }}
              disabled={
                !mnemo?.children
                  ?.find((el) => el.name === "Ссылки клиента")
                  ?.children.find((ele) => ele.mnemo === "insertBtn")
              }
            >
              Добавить
            </CButton>
          </div>
        )}
      </div>
    )
  }

  return (
    <>
      <AddAbonement
        abonementModal={isOpenAddEditModal}
        setAbonementModal={setIsOpenAddEditModal}
        dayModal={isOpenAddDayModal}
        setDayModal={setIsOpenAddDayModal}
        clientInfo={clientInfo}
      />
      <AddComment
        commentModal={isOpenAddCommentModal}
        setCommentModal={setIsOpenAddCommentModal}
        clientInfo={clientInfo}
        payload={payload}
      />
      <AddComment
        commentModal={isOpenAddCommentModal}
        setCommentModal={setIsOpenAddCommentModal}
        clientInfo={clientInfo}
        payload={payload}
      />
      <AddLink
        linkModal={isOpenAddLinkModal}
        setLinkModal={setIsOpenAddLinkModal}
        clientInfo={clientInfo}
        payload={payload}
      />
      <AddPacket
        packetModal={isOpenAddPacketModal}
        setPacketModal={setIsOpenAddPacketModal}
        clientInfo={clientInfo}
        payload={payload}
      />
      <AddStatus
        statusModal={isOpenAddStatusModal}
        setStatusModal={setIsOpenAddStatusModal}
        clientInfo={clientInfo}
        payload={payload}
      />
      {tab === "Абонементы" ? (
        window.innerWidth >= 768 ? (
          <ClientsAbonementsNew
            isActive={isActive}
            isDeleted={isDeleted}
            setPage={setPage}
            setPageSize={setPageSize}
            page={page}
            pageSize={pageSize}
            clientInfo={clientInfo}
            title={title}
            mnemo={mnemo}
          />
        ) : (
          tabPage === "Абонементы" && (
            <MobileClientsAbonements
              page={page}
              setPage={setPage}
              setPageSize={setPageSize}
              getAbonementsClientList={getAbonementsClientList}
              getAbonementsClientListLoading={getAbonementsClientListLoading}
              setAbonementInfo={setAbonementInfo}
              abonementInfo={abonementInfo}
              setIsOpenAddEditModal={setIsOpenAddEditModal}
              setTab={setTabPage}
              clientInfo={clientInfo}
              mnemo={mnemo}
            />
          )
        )
      ) : tab === "Проходы" ? (
        window.innerWidth >= 768 ? (
          <ClientsPassages
            setPage={setPage}
            setPageSize={setPageSize}
            page={page}
            pageSize={pageSize}
            clientInfo={clientInfo}
            title={title}
            mnemo={mnemo}
            passagesInfo={passagesInfo}
            setPassagesInfo={setPassagesInfo}
            payload={payload}
          />
        ) : (
          tabPage === "Проходы" && <div>Таблица проходов</div>
        )
      ) : tab === "Услуги" ? (
        window.innerWidth >= 768 ? (
          <ClientsTrainingNew
            page={page}
            setPage={setPage}
            setPageSize={setPageSize}
            pageSize={pageSize}
            clientInfo={clientInfo}
            title={title}
            isActive={isActive}
            mnemo={mnemo}
          />
        ) : (
          tabPage === "Услуги" && (
            <MobileClientsTrainings
              page={page}
              setPage={setPage}
              setPageSize={setPageSize}
              getClientTrainingsList={getClientTrainingsList}
              getClientTrainingsListLoading={getClientTrainingsListLoading}
              setIsTrainingInfo={setIsTrainingInfo}
              trainingInfo={trainingInfo}
              setIsOpenAddEditModal={setIsOpenAddEditModal}
              setTab={setTabPage}
              clientInfo={clientInfo}
              mnemo={mnemo}
            />
          )
        )
      ) : tab === "Транзакции" ? (
        window.innerWidth >= 768 ? (
          <ClientsTransactions
            setPage={setPage}
            setPageSize={setPageSize}
            page={page}
            pageSize={pageSize}
            clientInfo={clientInfo}
            title={title}
            mnemo={mnemo}
            transactionsInfo={transactionsInfo}
            setTransactionsInfo={setTransactionsInfo}
            payload={payload}
          />
        ) : (
          tabPage === "Транзакции" && (
            <MobileClientsTransactions
              page={page}
              setPage={setPage}
              setPageSize={setPageSize}
              transactionsInfo={transactionsInfo}
              setTransactionsInfo={setTransactionsInfo}
              clientInfo={clientInfo}
              getClientTransactionsList={getClientTransactionsList}
              getClientTransactionsListLoading={
                getClientTransactionsListLoading
              }
              setTab={setTabPage}
              mnemo={mnemo}
            />
          )
        )
      ) : tab === "Ссылки на оплату" ? (
        window.innerWidth >= 768 ? (
          <ClientLink
            setPage={setPage}
            setPageSize={setPageSize}
            page={page}
            pageSize={pageSize}
            clientInfo={clientInfo}
            title={title}
            mnemo={mnemo?.children?.find(
              (el) => el.mnemo === "paymentLinksTabel",
            )}
            linkInfo={linkInfo}
            setLinkInfo={setLinkInfo}
            payload={payload}
          />
        ) : (
          tabPage === "Ссылки на оплату" && (
            <MobileClientLink
              page={page}
              setPage={setPage}
              setPageSize={setPageSize}
              linkInfo={linkInfo}
              setLinkInfo={setLinkInfo}
              clientInfo={clientInfo}
              getClientLinkList={getClientLinkList}
              setIsOpenAddLinkModal={setIsOpenAddLinkModal}
              getClientLinkListLoading={getClientLinkListLoading}
              setTab={setTabPage}
              mnemo={mnemo}
            ></MobileClientLink>
          )
        )
      ) : tab === "Пакеты" ? (
        window.innerWidth >= 768 ? (
          <ClientPacket
            setPage={setPage}
            setPageSize={setPageSize}
            page={page}
            pageSize={pageSize}
            clientInfo={clientInfo}
            title={title}
            mnemo={mnemo?.children?.find(
              (el) => el.mnemo === "userPersonalPacketsTable",
            )}
            packetInfo={packetInfo}
            setPacketInfo={setPacketInfo}
            payload={payload}
          />
        ) : (
          tabPage === "Пакеты" && (
            <div></div>
            // <MobileClientPacket
            //   page={page}
            //   setPage={setPage}
            //   setPageSize={setPageSize}
            //   packetInfo={packetInfo}
            //   setPacketInfo={setPacketInfo}
            //   clientInfo={clientInfo}
            //   getClientPersonalPacketList={getClientPersonalPacketList}
            //   setIsOpenAddPacketModal={setIsOpenAddPacketModal}
            //   getClientPersonalPacketListLoading={
            //     getClientPersonalPacketListLoading
            //   }
            //   setTab={setTabPage}
            //   mnemo={mnemo}
            // ></MobileClientPacket>
          )
        )
      ) : tab === "Комментарии" ? (
        window.innerWidth >= 768 ? (
          <ClientsComments
            setPage={setPage}
            setPageSize={setPageSize}
            page={page}
            pageSize={pageSize}
            clientInfo={clientInfo}
            title={title}
            mnemo={mnemo?.children?.find((el) => el.mnemo === "commentsTable")}
            commentInfo={commentInfo}
            setCommentInfo={setCommentInfo}
            payload={payload}
          />
        ) : (
          tabPage === "Комментарии" && (
            <MobileClientsComments
              page={page}
              setPage={setPage}
              setPageSize={setPageSize}
              getCommentsList={commentsList}
              getCommentsListLoading={commentsListLoading}
              commentInfo={commentInfo}
              setIsOpenAddCommentModal={setIsOpenAddCommentModal}
              setCommentInfo={setCommentInfo}
              setIsOpenAddEditModal={setIsOpenAddEditModal}
              setTab={setTabPage}
              clientInfo={clientInfo}
              mnemo={mnemo}
            />
          )
        )
      ) : tab === "Статус" ? (
        window.innerWidth >= 768 ? (
          <ClientsStatus
            setPage={setPage}
            setPageSize={setPageSize}
            page={page}
            pageSize={pageSize}
            clientInfo={clientInfo}
            title={title}
            mnemo={null}
            statusInfo={statusInfo}
            setStatusInfo={setStatusInfo}
            payload={payload}
          />
        ) : (
          tabPage === "Статус" && <div>Мобильная версия статуса</div>
        )
      ) : null}
    </>
  )
}

export default ClientsExtraTable
